import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { UserUpdatePasswordModel } from 'src/app/models/authentication/user-update-password.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { UserTableModel } from 'src/app/models/tables/authentication/user-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private _httpClient: HttpClient) { }

  exportConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.ExportConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.GetColumnsForConsultationAsync}`);
  }

  getAllUsersWithPaginationAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<UserTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<UserTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.GetAllUsersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllProfilesForSelect(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.GetAllProfilesForSelectAsync}`,);
  }


  getUserById(userId: number | null): Observable<UserModel> {
    return this._httpClient.get<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.GetUserById}/${userId}`);
  }

  createUser(userModel: UserModel): Observable<UserModel> {
    return this._httpClient.post<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.CreateUser}`,
      userModel);
  }

  updateUser(userModel: UserModel): Observable<UserModel> {
    return this._httpClient.put<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.UpdateUser}`,
      userModel);
  }

  setActiveUser(userId: number): Observable<UserModel> {
    return this._httpClient.put<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.SetActiveUser}/${userId}`,
      null);
  }

  deleteUser(userId: number): Observable<UserModel> {
    return this._httpClient.delete<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.DeleteUser}/${userId}`);
  }

  getUserByUserName(userName: string): Observable<UserModel> {
    const itemFilterResponse = new ItemFilterModel("userName", null, null, "");
    itemFilterResponse.wildcard = userName;
    return this._httpClient.post<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.GetUserByUserName}`, itemFilterResponse);
  }

  updateUserPassword(userUpdatePasswordModel: UserUpdatePasswordModel): Observable<UserModel> {
    return this._httpClient.put<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.UpdateUserPassword}`,
      userUpdatePasswordModel);
  }

  UpdateUserAuthenticatedPassword(userUpdatePasswordModel: UserUpdatePasswordModel): Observable<UserModel> {
    return this._httpClient.put<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.UpdateUserAuthenticatedPassword}`,
      userUpdatePasswordModel);
  }

  userAuthenticatedIsADMIN(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.UserAuthenticatedIsADMIN}`);
  }

  userAuthenticatedIsASADMIN(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.UserAuthenticatedIsASADMIN}`);
  }

  userAuthenticatedIsPrincipalCompany(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.UserAuthenticatedIsPrincipalCompany}`);
  }

  getUserByBranchId(branchId: number | null): Observable<Array<UserModel>> {
    return this._httpClient.get<Array<UserModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.GetUserByBranchId}/${branchId}`);
  }

  getUserAutheticated(): Observable<UserModel> {
    return this._httpClient.get<UserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.user.GetUserAutheticated}`);
  }
}
